// eslint-disable-next-line no-shadow
enum LocalStorage {
  applied_filters = 'applied_filters'
}

// eslint-disable-next-line no-shadow
export enum Filters {
  timeSpan = 'timeSpan',
  timeSpanCustom = 'timeSpanCustom',
  dashboardGroup = 'dashboardGroup',
  dataParameters = 'dataParameters',
  alertParameters = 'alertParameters',
  alertDevices = 'alertDevices',
  alertTimeSpan = 'alertTimeSpan ',
  alertTimeSpanCustom = 'alertTimeSpanCustom',
  dataDevices = 'dataDevices',
  dataTimeSpan = 'dataTimeSpan',
  dataTimeSpanCustom = 'dataTimeSpanCustom',
  histogramParameter = 'histogramParameter',
  dashboardDevice = 'dashboardDevice',
  dashboardDataFilter = 'dashboardDataFilter',
  dataTrendsKeys = 'dataTrendsKeys',
  dataTrendsLegends = 'dataTrendsLegends',
  boxPlotParameters = 'boxPlotParameters',
  boxPlotDevices = 'boxPlotDevices',
  boxPlotAxisMode = 'boxPlotAxisMode',
  scatterDevices = 'scatterDevices',
  scatterParametersY = 'scatterParametersY',
  scatterParameterX = 'scatterParameterX',
  dashboardFlooMapParameters = 'dashboardFlooMapParameters',
  deviceListWidgetColumnOrder = 'deviceListWidgetColumnOrder',
  deviceSetupColumnOrder = 'deviceSetupColumnOrder',
  dashboardSimplified = 'dashboardSimplified',
  dashboardView = 'dashboardView',
  parameterWidgetIndex = 'parameterWidgetIndex'
}

type Filter = {
  key: Filters;
  data: any;
};

/**
 * Function to create unique filter key based on username.
 * @param key - Key of the filter.
 * @returns - Unique key.
 */
const createUniqueFilterKey = (key: Filters): string => {
  const currentUser = sessionStorage.getItem('user_name');
  return `${key}-${currentUser}`;
};
/**
 * Function to get list of applied filters.
 * @returns - List of applied filters.
 */
export function getAllAppliedFilters(): Filter[] {
  const filters = localStorage.getItem(LocalStorage.applied_filters);
  if (filters) {
    return JSON.parse(filters);
  }
  return [];
}

/**
 * Function to get list of applied filters.
 * @param key - Key of the filter.
 * @returns - List of applied filters.
 */
export function getAppliedFilter(key: Filters): Filter | null {
  const data = localStorage.getItem(LocalStorage.applied_filters);
  if (data) {
    const filters: Filter[] = JSON.parse(data);
    const filter = filters.filter((item) => item.key === createUniqueFilterKey(key));
    if (filter.length > 0) {
      return filter[0];
    }
    return null;
  }
  return null;
}

/**
 * Function to get list of applied filters.
 * @param newFilter - Applied filter.
 */
export function setAppliedFilter(newFilter: Filter): void {
  const oldFilters = getAllAppliedFilters();
  const filtersWithRemovedFilterWithKey = oldFilters.filter(
    (item) => item.key !== createUniqueFilterKey(newFilter.key)
  );
  localStorage.setItem(
    LocalStorage.applied_filters,
    JSON.stringify([
      ...filtersWithRemovedFilterWithKey,
      {
        key: createUniqueFilterKey(newFilter.key),
        data: newFilter.data
      }
    ])
  );
}
